import { render, staticRenderFns } from "./bulma.vue?vue&type=template&id=06af9a6c&scoped=true&"
import script from "./bulma.vue?vue&type=script&lang=js&"
export * from "./bulma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06af9a6c",
  null
  
)

export default component.exports